<template>
  <p v-if="editable || truthyModelValue.length" class="break-words text-sm font-bold capitalize text-gray-700 my-4">
    Exceptional Abilities
  </p>
  <div v-if="isEditing" class="flex flex-wrap gap-x-3 gap-y-2">
    <FormInput v-for="(num, index) in length" :key="index"
               :modelValue="modelValue[index] ?? ''"
               class="w-full sm:w-52"
               @update:modelValue="updateModelValue(index, $event)"/>
    <FormButton color="green" @click="setIsEditing(false)" class="block max-w-fit">
      Done
    </FormButton>
  </div>
  <div v-else-if="truthyModelValue.length > 0"
       @click="setIsEditing(true)"
       :class="editable && 'cursor-pointer hover:underline'"
       class="flex flex-wrap gap-x-3 gap-y-1 group/candidate-item">
    <div v-for="(item, index) in truthyModelValue" :key="index"
         class="rounded border border-slate-200 px-2 py-1" :class="!item && 'hidden'">
      {{ item }}
    </div>
    <PencilSquareIcon v-if="editable"
                      class="mt-2 block h-4 w-4 text-slate-600 opacity-50 group/candidate-item:opacity-100 transition-all ml-1.5"/>
  </div>
  <FormButton v-else-if="editable" color="gradient" @click="setIsEditing(true)"
              flex class="block">
    <PlusCircleIcon class="mr-1 h-4 w-4"/>
    <span>Add Your {{fieldName}}</span>
  </FormButton>
</template>

<script setup>
import FormButton from "./FormButton.vue";
import FormInput from "./FormInput.vue";
import {PencilSquareIcon, PlusCircleIcon} from "@heroicons/vue/24/solid/index.js";
import {computed, ref} from "vue";

const emits = defineEmits(["update:modelValue"]);
const props = defineProps({
  editable: Boolean,
  modelValue: Array,
  fieldName: String,
  length: {
    type: Number,
    default: 3,
  },
});

const isEditing = ref(false);

const setIsEditing = (value) => {
  if (!props.editable) return;
  isEditing.value = value;
};

const truthyModelValue = computed(() => {
  if (!props.modelValue) return [];
  return props.modelValue.filter((item) => item);
});

const updateModelValue = (index, value) => {
  if (!props.editable) return;

  let newModelValue;

  if (!props.modelValue) newModelValue = [];
  else newModelValue = [...props.modelValue];

  while (newModelValue.length < props.length) {
    newModelValue.push("");
  }

  newModelValue[index] = value || "";

  emits("update:modelValue", newModelValue);
};
</script>
